export default class extends HTMLElement {
  connectedCallback() {
    this.button.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    // Prevent default form submission
    event.preventDefault();
    
    // Show loading indicator
    const loadingId = this.button.dataset.loadingId;
    if (loadingId) {
      const loadingElement = document.getElementById(loadingId);
      if (loadingElement) {
        loadingElement.classList.remove('hidden');
      }
    }
    
    // Set cookie with 10-year expiration
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 10);
    const expires = expirationDate.toUTCString();
    document.cookie = `${this.dataset.key}=${this.dataset.value}; expires=${expires}; path=/`;
    
    // Get the form element
    const form = this.closest('form');
    
    // Add a hidden input to the form with the cookie value
    let input = form.querySelector(`input[name="${this.dataset.key}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = this.dataset.key;
      form.appendChild(input);
    }
    input.value = this.dataset.value;
    
    // requestSubmit (unlike submit) goes through Turbo Drive, so the page swaps
    // in place with the page transition instead of a full reload.
    form.requestSubmit();
  }

  get button() {
    return this.querySelector('button');
  }
}
